import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import { makeStyles } from "@mui/styles";
import { SEMANTIC_RELEASE_VERSION } from "../util/versions";
import HamburgerMenuCollapsibleMenuItem from "./HamburgerMenuCollapsibleMenuItem";
import HamburgerMenuListItem from "./HamburgerMenuListItem";
import { isNewHomeDashboardActive } from "../util/dashboard/dashboardUtils";

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    position: "relative",
    width: 240,
  },
  toolbarMargin: theme.mixins.toolbar,
  versionText: {
    color: theme.palette.secondary.swaGray3,
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "pre-line",
    margin: "10px",
  },
}));

const sortOrder = [
  "home",
  "timeOffRequest",
  "tradeForm",
  "bid",
  "tempAssignment",
  "overtime",
  "generateReport",
  "seniorityList",
  "schedule",
  "employeeDataManagement",
  "declarations",
  "accessExceptions",
];

const HamburgerMenu = (props) => {
  const classes = useStyles();

  const renderHamburgerMenuItems = () => {
    const hamburgerMenuItems = props.userFeatures.sort(function (a, b) {
      return sortOrder.indexOf(a.key) - sortOrder.indexOf(b.key);
    });
    return hamburgerMenuItems.map((menuItem, idx) => {
      // If the New Home Dashboard is active, skip rendering the old Home Page
      if (isNewHomeDashboardActive(hamburgerMenuItems, menuItem)) {
        return "";
      }

      if (menuItem.childItems.length > 0) {
        if (props.isDesktopView || menuItem.childItems.some((childItem) => childItem.isActiveOnMobile)) {
          return (
            <HamburgerMenuCollapsibleMenuItem
              key={idx}
              menuItemConfig={menuItem}
              openCascadeMenu={props.openCascadeMenu}
              onParentMenuItemClick={props.onParentMenuItemClick}
              onChildMenuItemClick={props.onChildMenuItemClick}
              selectedMenuItem={props.selectedMenuItem}
              isDesktopView={props.isDesktopView}
            />
          );
        } else {
          return "";
        }
      } else {
        return (
          <HamburgerMenuListItem
            key={idx}
            menuItemConfig={menuItem}
            onClick={props.onMenuItemClick()}
            selected={props.selectedMenuItem === menuItem.path}
            isDesktopView={props.isDesktopView}
          >
            <ListItemText>{menuItem.label}</ListItemText>
          </HamburgerMenuListItem>
        );
      }
    });
  };

  return (
    <div data-testid="hamburger-menu-component">
      <Drawer
        open={props.open}
        onClose={props.onClose}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <List>
          {renderHamburgerMenuItems()}

          <HamburgerMenuListItem
            isParent={true}
            menuItemConfig={{
              isActiveOnMobile: true,
            }}
            onClick={props.logMeOut}
            selected={false}
            isDesktopView={props.isDesktopView}
          >
            <ListItemText>Log Out</ListItemText>
          </HamburgerMenuListItem>
        </List>
        <span className={classes.versionText}>{SEMANTIC_RELEASE_VERSION}</span>
      </Drawer>
    </div>
  );
};

export default HamburgerMenu;
